exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-prompt__modal__1GlIK{background-color:rgba(22,45,61,.6)}.preview-prompt__modal-content__KDjSu{padding:0}.preview-prompt__prompt-wrapper__SvFMd{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;padding:40px 30px 30px}.preview-prompt__second-message__1-T-Q{margin-bottom:30px}.preview-prompt__close-button__X479Z{-ms-flex-item-align:end;align-self:flex-end;height:30px;padding:0 30px}", ""]);

// exports
exports.locals = {
	"modal": "preview-prompt__modal__1GlIK",
	"modal-content": "preview-prompt__modal-content__KDjSu",
	"modalContent": "preview-prompt__modal-content__KDjSu",
	"prompt-wrapper": "preview-prompt__prompt-wrapper__SvFMd",
	"promptWrapper": "preview-prompt__prompt-wrapper__SvFMd",
	"second-message": "preview-prompt__second-message__1-T-Q",
	"secondMessage": "preview-prompt__second-message__1-T-Q",
	"close-button": "preview-prompt__close-button__X479Z",
	"closeButton": "preview-prompt__close-button__X479Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/preview-prompt/preview-prompt.styl
// module id = 1299
// module chunks = 0 1 2 3